import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import { getAnalytics } from "firebase/analytics";
import { getStorage} from "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyB9proFUl93sTsvg3O1faPGAtohjYLOjY0",
    authDomain: "kinematics-classes.firebaseapp.com",
    projectId: "kinematics-classes",
    storageBucket: "kinematics-classes.appspot.com",
    messagingSenderId: "993810036623",
    appId: "1:993810036623:web:c52eec53a3fd1c6d03fdfa",
    measurementId: "G-1XSRVN7Q50"
  };
// const firebaseConfig = {
//   apiKey: "AIzaSyC7F420lvq18aZZgFwV6Eu5S0Yjly7Y854",
//   authDomain: "kinematic-dev.firebaseapp.com",
//   projectId: "kinematic-dev",
//   storageBucket: "kinematic-dev.appspot.com",
//   messagingSenderId: "1060892747447",
//   appId: "1:1060892747447:web:51fea225aa272daed04f32",
//   measurementId: "G-T52YCHQQXS"
// };
const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebase.auth();
const analytics = getAnalytics(firebaseApp);
const storage = getStorage(firebaseApp);

export { db, auth, analytics,firebaseApp,storage};